import { render, staticRenderFns } from "./BookingsInvoice.vue?vue&type=template&id=37647dc4&"
import script from "./BookingsInvoice.vue?vue&type=script&lang=js&"
export * from "./BookingsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports